import { render } from "./rssIcon.vue?vue&type=template&id=2cc07ea9"
import script from "./rssIcon.vue?vue&type=script&lang=js"
export * from "./rssIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__